import PostSlider from '../utils/_post-slider'

const $ = jQuery

export default function PostSliders () {
  /**
   * For articles
   */
  const ARTICLE_WRAPPERS = document.querySelectorAll('.mtt-articles')
  if (ARTICLE_WRAPPERS.length) {
    for (let i = 0; i < ARTICLE_WRAPPERS.length; i++) {
      new PostSlider(ARTICLE_WRAPPERS[i], 'filter_articles', 1200)
    }
  }
}
